exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__user-card-body___3p82e{padding:1rem;padding-top:4rem}.styles__user-card-body___3p82e .styles__user-card-name___3VFjy{display:flex;justify-content:center;font-size:1.25rem;margin-bottom:.25rem;color:#2c3e50}.styles__user-card-body___3p82e .styles__user-card-position-name___2Yu6-{display:flex;justify-content:center;font-size:.75rem;color:#7f8c8d}", ""]);

// exports
exports.locals = {
	"user-card-body": "styles__user-card-body___3p82e",
	"user-card-name": "styles__user-card-name___3VFjy",
	"user-card-position-name": "styles__user-card-position-name___2Yu6-"
};